import { render, staticRenderFns } from "./PerScoreTable_ssdt.vue?vue&type=template&id=7bfb5e26&scoped=true&"
import script from "./PerScoreTable_ssdt.vue?vue&type=script&lang=js&"
export * from "./PerScoreTable_ssdt.vue?vue&type=script&lang=js&"
import style0 from "./PerScoreTable_ssdt.vue?vue&type=style&index=0&id=7bfb5e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb5e26",
  null
  
)

export default component.exports